import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "./ApiRequest";
import { CategoryFlow } from "./EndPoints";

export const GetCategories = (currentPage = "", pageSize = "") => {
  let url = `${CategoryFlow.CATEGORIES}`;
  const params = [];
  if (currentPage !== undefined && currentPage !== null) {
    params.push(`page=${currentPage}`);
  }
  if (pageSize !== undefined && pageSize !== null) {
    params.push(`per_page=${pageSize}`);
  }

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return getRequest(url);
};
export const GetSectionCategoriesAPI = (
  id,
  currentPage = "",
  pageSize = "",
  query = "",
  order = ""
) => {
  return getRequest(
    `${CategoryFlow.SECTION_CATEGORIES}/${id}/categories?query=${query}&order=${order}&page=${currentPage}&per_page=${pageSize}`
  );
};
export const CreateSectionCategoriesAPI = (id, payload) => {
  return postRequest(
    `${CategoryFlow.SECTION_CATEGORIES}/${id}/categories`,
    payload
  );
};
export const UpdateSectionCategoriesAPI = (id, catId, payload) => {
  return patchRequest(
    `${CategoryFlow.SECTION_CATEGORIES}/${id}/categories/${catId}`,
    payload
  );
};
export const DeleteSectionCategoriesAPI = (id, catId) => {
  return deleteRequest(
    `${CategoryFlow.SECTION_CATEGORIES}/${id}/categories/${catId}`
  );
};
export const GetSectionSubCategoriesAPI = (
  id,
  currentPage = "",
  pageSize = "",
  query = "",
  cat_id = "",
  order = ""
) => {
  return getRequest(
    `${CategoryFlow.SECTION_CATEGORIES}/${id}/subcategories?category=${cat_id}&query=${query}&order=${order}&page=${currentPage}&per_page=${pageSize}`
  );
};

export const CreateSectionSubCategoriesAPI = (id, payload) => {
  return postRequest(
    `${CategoryFlow.SECTION_CATEGORIES}/${id}/subcategories`,
    payload
  );
};
export const UpdateSectionSubCategoriesAPI = (id, catId, payload) => {
  return patchRequest(
    `${CategoryFlow.SECTION_CATEGORIES}/${id}/subcategories/${catId}`,
    payload
  );
};
export const DeleteSectionSubCategoriesAPI = (id, catId) => {
  return deleteRequest(
    `${CategoryFlow.SECTION_CATEGORIES}/${id}/subcategories/${catId}`
  );
};

export const CreateCategory = (payload) => {
  return postRequest(CategoryFlow.CATEGORIES, payload);
};
export const UpdateCategory = (id, payload) => {
  return patchRequest(`${CategoryFlow.CATEGORIES}${id}`, payload);
};
export const DeleteCategory = (id) => {
  return deleteRequest(`${CategoryFlow.CATEGORIES}${id}`);
};
// sub categories
export const getSubCategories = (currentPage, pageSize) => {
  return getRequest(
    `${CategoryFlow.SUB_CATEGORIES}?page=${currentPage}&per_page=${pageSize}`
  );
};

export const CreateSubCategory = (payload) => {
  return postRequest(CategoryFlow.SUB_CATEGORIES, payload);
};
export const UpdateSubCategory = (id, payload) => {
  return patchRequest(`${CategoryFlow.SUB_CATEGORIES}${id}`, payload);
};

export const DeleteSubCategory = (id) => {
  return deleteRequest(`${CategoryFlow.SUB_CATEGORIES}${id}`);
};
